module.exports = __webpack_public_path__ + "img/icon-info.6e7802c9.svg";